export const GETROLE = 'GETROLE'
export const GETSELECTROLE = 'GETSELECTROLE'
export const ADDROLE = 'ADDROLE'
export const UPDATEROLE = 'UPDATEROLE'
export const DELETEROLE = 'DELETEROLE'
export const GETMENUOFTERR = 'GETMENUOFTERR'
export const GETSELECTMENUOFTERR = 'GETSELECTMENUOFTERR'
export const ADDMENU = 'ADDMENU'
export const UPDATEMENU = 'UPDATEMENU'
export const DELETEMENU = 'DELETEMENU'
export const GETTREE = 'GETTREE'
export const GETUSERPAGE = 'GETUSERPAGE'
export const SAASUSERADD = 'SAASUSERADD'
export const SAASUSERUPDATE = 'SAASUSERUPDATE'
export const SAASUSERDEL = 'SAASUSERDEL'
export const SAASUSERDISABLED = 'SAASUSERDISABLED'
export const SAASUSERRESETPWD = 'SAASUSERRESETPWD'

/*
* 组织机构
* */
/*
* 角色管理
* */
export const GETROLEPAGE = 'GETROLEPAGE'
export const GETROLEADD = 'GETROLEADD'
export const GETROLEUPDATE = 'GETROLEUPDATE'
export const GETROLEUPDATESTATUS = 'GETROLEUPDATESTATUS'
export const GETMENUROLETREE = 'GETMENUROLETREE'
export const SAASGETUSERPAGES = 'SAASGETUSERPAGES'

export const SAASGETUSERROLE = 'SAASGETUSERROLE'



// WEBPACK FOOTER //
// ./src/store/saasManage/types.js